import type React from 'react';
import { useReducer } from 'react';

import { ChevronDownIcon, ChevronUpIcon } from '@vlabs/icons';
import { IconButton } from '@vlabs/uikit/components/controls/button/icon-button/IconButton';
import classNames from 'classnames';

import st from './useTogglableTable.module.sass';

interface UseTogglableTableProps {
  table: React.ReactNode;
}

interface UseTogglableTableReturn {
  toggle: React.ReactNode;
  isOpen: boolean;
  table: React.ReactNode;
}

function useTogglableTable({
  table,
}: UseTogglableTableProps): UseTogglableTableReturn {
  const [isOpen, toggleIsOpen] = useReducer((state) => !state, false);
  const toggle = (
    <IconButton
      icon={isOpen ? <ChevronUpIcon /> : <ChevronDownIcon />}
      kind="secondary"
      onClick={toggleIsOpen}
      shape="square"
      size="small"
      variant="dimmed"
    />
  );

  const wrappedTable = (
    <div
      className={classNames(st.Fold, {
        [st.Fold_isOpen as string]: isOpen,
      })}
    >
      {table}
    </div>
  );

  return {
    toggle,
    isOpen,
    table: wrappedTable,
  };
}

export { useTogglableTable };
